import React from 'react';
import { useHistory } from 'react-router-dom';

import './style.scss';

const NotFoundPage = () => {
  const history = useHistory();

  const handleRedirect = () => {
    history.push('/');
  };

  return (
    <div className="container not-found">
      <div className="not-found-body">
        <h1>404</h1>
        <h4>Извините, мы не можем найти эту страницу!</h4>
        <p>Страница, которую вы ищете не найдена.</p>
        <div>
          <a href="/" onClick={handleRedirect} className="not-found-btn">
            На главную
          </a>
        </div>
      </div>
    </div>
  );
};

export { NotFoundPage };
